import { Link } from 'react-router-dom';
import { Article } from '@/mocks/articles';

interface ArticleSectionProps {
  title: string;
  subtitle?: string;
  articles: Article[];
}

export default function ArticleSection({ title, subtitle, articles }: ArticleSectionProps) {
  return (
    <section className="w-full px-4 md:px-6 py-14 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            {title}
          </h2>
          {subtitle && (
            <p className="text-sm text-secondary-500 mt-2">{subtitle}</p>
          )}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articles.map((article) => (
            <article key={article.id}>
              <Link
                to={`/article/${article.id}`}
                className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300"
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              >
                <div className="aspect-[16/9] overflow-hidden bg-secondary-100">
                  <img
                    src={article.image}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-xs px-2 py-0.5 bg-secondary-100 text-secondary-600 rounded-full whitespace-nowrap">
                      {article.category}
                    </span>
                    <span className="text-xs text-secondary-400 whitespace-nowrap">{article.date}</span>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                    {article.title}
                  </h3>
                  <p className="text-xs md:text-sm text-secondary-500 line-clamp-2 leading-relaxed">
                    {article.summary}
                  </p>
                  <div className="mt-3 flex items-center gap-1 text-xs text-primary-500 font-medium">
                    阅读全文 <i className="ri-arrow-right-line text-[10px]"></i>
                  </div>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}